import { border, borderRadius, maxWidth, width } from "@mui/system";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    // maxWidth: "1070px",
    gap: 3,
  },
  containerPaper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    padding: "20px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    width: "100%",
    p: 3,
    borderRadius: "16px",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  gridPaper: {
    borderRadius: "16px",
    backgroundColor: "red",
    p: 2,
    backgroundColor: theme.palette.background.paper,
    margin: "10px 5px 0 5px",
  },
  boxSubTitle: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    mb: 1,
  },
  paperSearchCliente: {
    p: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    width: "100%",
  },
  paperSearchCardCliente: {
    p: 1,
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "space-between",
    gap: 0.4,
    width: "100%",
    alignItems: "center",
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: "16px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "800px",
  },
  containerDataSearch: {
    display: "flex",
    flexDirection: "column",
    p: 1,
    width: "100%",
    flex: 1,
    minWidth: 0,
  },
  containerButtonSearch: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 45px",
  },

  boxDataCard: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    justifyContent: "space-between",
    width: "100%",
  },
  subDataCard: {
    fontWeight: "bold",
    fontSize: "14px",
    opacity: 0.6,
  },
  boxDivider: { width: "100%", margin: "20px 0px 10px 0px" },
  textfield: {
    width: "100%",
    "& .MuiInputLabel-filled": {
      transform: "translate(12px, 8px) scale(1)", // Posição padrão (não focada)
      "&.MuiInputLabel-shrink": {
        transform: "translate(12px, -9px) scale(0.75)", // Posição quando sobe (focada/preenchida)
      },
    },
    "& .MuiFilledInput-input": {
      // Ajustes específicos para o tamanho small
      paddingTop: "6px !important", // Reduz o padding para ficar compacto
      paddingBottom: "10px !important",
      fontSize: "0.875rem !important", // Tamanho de fonte padrão para small
    },
  },
  asTextField: {
    width: "49%",
    minWidth: "250px",
    "@media (max-width: 1040px)": {
      width: "100%",
    },
    "& .MuiInputLabel-root.Mui-error": {
      color: "secondary.main",
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      border: "3px solid",
      borderColor: "secondary.main",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "secondary.main",
    },
  },
  boxForm: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    width: "100%",
  },
});

export default styles;
